import { useScrollToHash } from "../../hooks"
import { AnimalSection, FamilySection, PortraitSection } from "./sections"
import "./ServicesPage.scss"

export const ServicesPage: React.FC = () => {
  useScrollToHash()
  return (
    <div className="services-page-outer-shell">
      <div className="inner-shell hide-scrollbar">
        <section id="animal">
          <AnimalSection />
        </section>
        <section id="portrait">
          <PortraitSection />
        </section>
        <section id="family">
          <FamilySection />
        </section>
      </div>
    </div>
  )
}
